import { useEffect, useState } from "react";
import { Trash2, Mail, Check, Phone } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminMessagesPage() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = () => {
        setLoading(true);
        api.get("/admin/messages").then((r) => setItems(r.data || [])).finally(() => setLoading(false));
    };

    useEffect(() => { load(); }, []);

    const onMarkRead = async (id) => {
        await api.put(`/admin/messages/${id}/read`);
        load();
    };

    const onDelete = async (id) => {
        if (!window.confirm("Изтриване на съобщението?")) return;
        await api.delete(`/admin/messages/${id}`);
        load();
    };

    return (
        <div data-testid="admin-messages-page">
            <h1 className="font-display text-4xl tracking-tightest mb-2">Съобщения</h1>
            <p className="text-ink-muted mb-10">Запитвания от контактната форма</p>

            {loading ? (
                <div className="text-ink-muted">Зареждане…</div>
            ) : items.length === 0 ? (
                <div className="text-ink-muted p-8 bg-surface border border-line rounded-2xl text-center">
                    Няма получени съобщения.
                </div>
            ) : (
                <div className="space-y-4">
                    {items.map((m) => (
                        <div
                            key={m.id}
                            className={`bg-surface border rounded-2xl p-6 ${m.read ? "border-line" : "border-gold/40"}`}
                            data-testid={`admin-message-${m.id}`}
                        >
                            <div className="flex items-start justify-between gap-4 flex-wrap">
                                <div className="flex-1 min-w-[200px]">
                                    <div className="font-medium text-lg flex items-center gap-2">
                                        {m.name}
                                        {!m.read && (
                                            <span className="text-[9px] uppercase tracking-[0.3em] text-gold bg-gold/10 px-2 py-0.5 rounded-full">
                                                Ново
                                            </span>
                                        )}
                                    </div>
                                    <div className="flex flex-wrap gap-4 mt-2 text-xs text-ink-muted">
                                        <a href={`mailto:${m.email}`} className="flex items-center gap-1 hover:text-gold">
                                            <Mail size={12} /> {m.email}
                                        </a>
                                        {m.phone && (
                                            <a href={`tel:${m.phone}`} className="flex items-center gap-1 hover:text-gold">
                                                <Phone size={12} /> {m.phone}
                                            </a>
                                        )}
                                        <span>{new Date(m.created_at).toLocaleString("bg-BG")}</span>
                                    </div>
                                </div>
                                <div className="flex gap-2">
                                    {!m.read && (
                                        <button
                                            onClick={() => onMarkRead(m.id)}
                                            className="w-9 h-9 rounded-lg border border-line hover:border-gold hover:text-gold flex items-center justify-center"
                                            data-testid={`message-mark-read-${m.id}`}
                                        >
                                            <Check size={14} />
                                        </button>
                                    )}
                                    <button
                                        onClick={() => onDelete(m.id)}
                                        className="w-9 h-9 rounded-lg border border-line hover:border-red-500 hover:text-red-400 flex items-center justify-center"
                                        data-testid={`message-delete-${m.id}`}
                                    >
                                        <Trash2 size={14} />
                                    </button>
                                </div>
                            </div>
                            {m.subject && <div className="mt-4 font-medium text-gold/90">{m.subject}</div>}
                            <p className="text-ink-muted mt-2 leading-relaxed text-sm whitespace-pre-line">
                                {m.message}
                            </p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
